export default "__VITE_ASSET__a0Zt6ka8__"